import React from "react";
import { Currency } from "types/general";
import { useIntl } from "react-intl";

import "./VatInfo.less";

export type VatInfoProps = {
  currency: Currency,
  cost: number,
}

export function VatInfo(props: VatInfoProps) {
  const { cost, currency } = props;
  const intl = useIntl();

  return (
    <div className="vat-info">
      <div>
        {intl.formatMessage({ id: "jmix-store.vat-info.title" })}
      </div>
      <div>
        {currency.sign}{cost}
      </div>
    </div>
  );
}